/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-actions/content-control-studio-actions.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  flex-shrink: 0;
  align-self: stretch;
  padding: 20px 0;
}
.navigation-bar {
  display: flex;
  padding: 20px;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 10px;
  gap: 20px;
}
.navigation-bar span {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.35);
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
}
.navigation-bar span:hover {
  color: rgba(0, 0, 0, 0.55);
}
.navigation-bar span.active {
  color: rgba(0, 0, 0, 0.85);
}
button {
  border-color: rgba(0, 0, 0, 0.14);
  color: rgba(0, 0, 0, 0.54);
  border-radius: 4px;
  padding: 9px 16px 9px 16px;
  position: relative;
  overflow: hidden;
  text-align: center;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-transform: uppercase;
}
button.action {
  background: rgb(45, 187, 252);
  border-color: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  align-self: flex-end;
}
.video-clips-search {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 20px;
  position: relative;
}
.video-clips-search input {
  width: 100%;
  height: 40px;
  padding: 5px 40px 5px 10px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  background: white;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  outline: none;
}
.video-clips-search input::placeholder {
  color: rgba(0, 0, 0, 0.35);
}
.video-clips-search input:focus {
  border-color: rgba(35, 47, 58, 0.3);
}
.video-clips-search .video-clips-search-icon {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
}
.video-clips-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  padding: 0 20px;
  overflow-y: auto;
  flex: 1;
}
.video-clips-list .video-clip-item {
  display: flex;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  width: 100%;
  margin-bottom: 2px;
}
.video-clips-list .video-clip-item .video-clip-thumbnail {
  width: 96px;
  height: 54px;
  flex-shrink: 0;
  background: white;
  overflow: hidden;
}
.video-clips-list .video-clip-item .video-clip-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  pointer-events: none;
}
.video-clips-list .video-clip-item .video-clip-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  padding: 5px 10px 5px 12px;
  min-width: 0;
  background: white;
  align-self: stretch;
}
.video-clips-list .video-clip-item .video-clip-details .video-clip-name {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.video-clips-list .video-clip-item .video-clip-details .video-clip-duration {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.54);
  line-height: 20px;
}
.video-clips-list .video-clip-item .video-clip-add {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 54px;
  flex-shrink: 0;
  background: #e9f8ff;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 18px;
  color: #1a9cd8;
  line-height: 1;
}
.video-clips-list .video-clip-item .video-clip-add:hover {
  background: #d0f0ff;
}
.container {
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
  user-select: none;
  gap: 5px;
  width: 100%;
}
.container.reveal .container-head .more-arrow {
  animation: rotate90 0.1s forwards;
  transform-origin: center;
}
.container.reveal .container-body {
  display: flex;
  height: max-content;
}
.container .container-head {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  min-height: 50px;
  width: 100%;
}
.container .container-head span {
  flex: 0 0 50%;
  display: flex;
  padding-top: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: uppercase;
  align-self: baseline;
}
.container .container-head .buttons {
  flex-grow: 1;
  display: flex;
  gap: 5px;
  min-width: 1px;
  flex-direction: column;
}
.container .container-head .buttons .row {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}
.container .container-head .buttons .row.disallow ::ng-deep evrideo-content-control-studio-action-button div {
  cursor: not-allowed;
}
.container .container-head .buttons .row.disallow ::ng-deep evrideo-content-control-studio-action-button div img {
  cursor: not-allowed;
}
.container .container-body {
  border-top: 1px solid rgba(0, 0, 0, 0.14);
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
  transition: max-height 0.5s forwards;
  height: 0;
  padding: 15px 20px;
  overflow: hidden;
  display: none;
  flex-direction: column;
  justify-content: space-between;
  -webkit-user-select: none;
  user-select: none;
  gap: 5px;
  width: 100%;
}
.container .container-body .adjustments {
  display: flex;
  flex-direction: column;
  gap: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.container .container-body .adjustments > div {
  display: flex;
  gap: 5px;
  flex-direction: column;
  width: 95%;
}
.container .container-body .adjustments > div .mat-mdc-slider {
  width: 100%;
}
.container .container-body .adjustments > div .slider-label-container {
  display: flex;
  justify-content: space-between;
  margin: 20px 10px 0;
  width: 100%;
}
.container .container-body .adjustments > div .slider-label-container .slider-value-label {
  font-weight: 700;
}
/*# sourceMappingURL=content-control-studio-actions.component.css.map */
